// extracted by mini-css-extract-plugin
export default {"separatorLine":"ifWxdEzmmRU72l910NJY"};